import  { jwtServerInstance }  from '../index'
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'
import {getJwtToken} from "../../lib/utils";

//查询所有数据字典项
export const getAllB2cBackInfos = () => {
    return jwtServerInstance.request({
        url:'/b2cbackcard/allbackInfo',
        method:'post'
    })
}


export const uploaderToServer = (file) =>{
    return jwtServerInstance.request({
        headers:{
            'Content-Type': 'multipart/form-data',
            'JWTHeaderName': getJwtToken()
        },
        url: '/taskservice/file/upload',
        method: 'post',
        data: file
    });
}

//查询所有数据字典项
export const addIdCardVerifyData = (dataForm) => {
    return jwtServerInstance.request({
        url:'/b2cidcard/add',
        method:'post',
        data:dataForm
    })
}

//查询所有数据字典项
export const getIdCardVerifyData = () => {
    return jwtServerInstance.request({
        url:'/b2cidcard/queryuseridcard',
        method:'post'
    })
}

//查询所有数据字典项
export const addBackCardData = (dataForm) => {
    return jwtServerInstance.request({
        url:'/b2customer/addbackInfo',
        method:'post',
        data:dataForm
    })
}

export const getBackCard=() =>{
    return jwtServerInstance.request({
        url:'/b2customer/query',
        method:'post'
    })
}

export const commitCashOutMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/add',
        method:'post',
        data:queryForm
    })
}

export const queryCashOutPromptStr = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querycashoutstring',
        method:'post'
    })
}

export const queryCashOutLimitMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querycashoutlimit',
        method:'post'
    })
}

export const queryUserMoney = (queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2ccashoutmoney/querybalancemoney',
        method:'post',
        data:qs.stringify({
            userId:queryForm.b2cUsersId
        })
    })
}

export const getCustomerMoneyInfo=() =>{
    return jwtServerInstance.request({
        url:'/b2customer/querymoneyInfo',
        method:'post'
    })
}


export const getOrderOpreationTime=(queryForm) =>{
    return jwtServerInstance.request({
        url:'/b2customer/queryctimelimit',
        method:'post',
        data:qs.stringify({
            orderNumber: queryForm.orderNumber,
            taskTypeId:queryForm.b2cTaskTypeId
        })
    })
}


export const getSysOrderSetting=() =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/queryosetting',
        method:'post'
    })
}

export const queryBackCardSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/querybcardsetting',
        method:'post'
    });
}

export const addInvestMoney = (dialogForm) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/add',
        method:'post',
        data:dialogForm
    })
}

export const transferMoney = (ustdAddress, transferMoney) => {
    return jwtServerInstance.request({
        url:'/b2cinvestmoney/transfermoney',
        method:'post',
        data: qs.stringify({
            ustdAddress: ustdAddress,
            transferMoney: transferMoney
        })
    })
}
